<template>
  <VDialog
    :value="$store.state.ui.loginModal"
    persistent
    width="500"
    @input="$store.commit('ui/setLoginModal', { value: $event })"
  >
    <VCard
      class="mx-auto"
      max-width="500"
    >
      <VCardTitle class="title font-weight-regular justify-space-between">
        <span>{{ TITLE[ui.step] }}</span>
        <VBtn
          :disabled="ui.submitting"
          text
          @click="
            $store.commit('ui/setLoginModal', { value: false }),
            $store.commit('ui/setBitrixLoginModal', { value: true })"
          v-text="'Через Битрикс24'"
        />
      </VCardTitle>

      <VWindow v-model="ui.step">
        <VWindowItem :value="1">
          <VCardText>
            <VTextField
              ref="email"
              v-model="model.email"
              label="Email"
              autofocus
              @keydown.enter="model.email.includes('@') ? (ui.step = 2) : null"
              @keydown.tab.prevent="model.email.includes('@') ? (ui.step = 2) : null"
            />
            <span class="caption grey--text text--darken-1">
              E-mail для входа в {{ $const.APP_NAME }}
            </span>
          </VCardText>
        </VWindowItem>

        <VWindowItem :value="2">
          <VCardText>
            <VTextField
              ref="password"
              v-model="model.password"
              label="Пароль"
              type="password"
              autofocus
              @keydown.enter="submit()"
            />
            <span class="caption grey--text text--darken-1">
              Пожалуйста, введите ваш пароль для входа
            </span>
          </VCardText>
        </VWindowItem>

        <VWindowItem
          :value="3"
        >
          <VCardText>
            <VSelect
              ref="companyCode"
              v-model="model.companyCode"
              :style="(data.availableCompanies || model.companyCode) ? '' : 'visibility: hidden'"
              label="Компания"
              :items="data.availableCompanies"
              item-text="name"
              item-value="code"
              autofocus
              @keydown.native.enter="submit()"
            />
            <span class="caption grey--text text--darken-1">
              Пожалуйста, введите выберите компанию
            </span>
          </VCardText>
        </VWindowItem>
      </VWindow>

      <VDivider />

      <VCardActions>
        <VBtn
          :disabled="ui.submitting"
          text
          @click="
            ui.step > 1
              ? (--ui.step, undefined)
              : $store.commit('ui/setLoginModal', { value: false })"
          v-text="ui.step === 1 ? 'Отмена' : 'Назад'"
        />
        <VSpacer />
        <VBtn
          :disabled="
            ui.submitting ||
              (ui.step === 1 && !model.email.includes('@')) ||
              (ui.step === 2 && (!model.email.includes('@') || !model.password)) ||
              (ui.step === 3 && (!model.email.includes('@') || !model.password || !model.companyCode))
          "
          :loading="ui.submitting"
          color="primary"
          depressed
          @click="ui.step === 1 ? (ui.step = 2) : submit()"
        >
          {{ ui.step === 1 ? 'Далее' : 'Войти' }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  data: function() {
    return {
      TITLE: Object.freeze({
        1: 'Авторизация на ' + this.$const.APP_NAME,
        2: 'Добро пожаловать!',
        3: 'Выберите компанию',
      }),
      model: {
        email: '',
        password: '',
        companyCode: null,
      },
      data: {
        availableCompanies: null,
      },
      ui: {
        step: 1,
        submitting: false,
        error: null,
      },
    }
  },
  watch: {
    'ui.step': {
      handler: 'focus',
      immediate: true,
    },
    '$store.state.ui.loginModal': {
      handler(isOpen) {
        if (isOpen) {
          this.focus()
        } else {
          this.model.password = ''
          this.model.companyCode = null
          this.data.availableCompanies = null
          this.ui.step = 1
          this.ui.error = null
        }
      },
      immediate: true,
    },
  },
  created() {
    this.$root.$on('app:register', this.onRegister)
    this.$once('hook:beforeDestroy', () =>
      this.$root.$off('app:register', this.onRegister))
  },
  methods: {
    onRegister({ email, password }) {
      const { $store } = this
      $store.commit('ui/setLoginModal', { value: true })
      this.$nextTick()
        .then(() => {
          this.model.email = email
          this.model.password = password
          this.ui.step = 2
          return this.$nextTick()
        })
        .then(this.submit)
    },
    submit() {
      const {
        model: { email, password, companyCode },
        data: { availableCompanies },
        ui: { step, submitting },
      } = this
      if (
        !email ||
        !password ||
        step === 1 ||
        (availableCompanies && !companyCode) ||
        submitting
      ) { return }
      this.ui.submitting = true
      this.ui.error = null
      this.$store.dispatch('auth/logIn', { email, password, companyCode })
        .catch(e => {
          this.data.availableCompanies = null
          this.ui.step = 2
          this.ui.error = `${e.message}: попробуйте еще раз`
          throw e
        })
        .then(res => {
          if (res.companies) {
            this.data.availableCompanies = res.companies
            this.model.companyCode = res.companies.length
              ? res.companies[0].code
              : null
            this.ui.step = 3
          } else {
            this.data.availableCompanies = null
            this.$store.dispatch('user/getCurrent')
            this.$store.commit('ui/setLoginModal', { value: false })
          }
        })
        .finally(() => { this.ui.submitting = false })
    },
    focus() {
      const {
        ui: { step },
      } = this
      this.$nextTick().then(() => {
        const refToFocus = {
          1: () => this.$refs.email,
          2: () => this.$refs.password,
          3: () => this.$refs.companyCode,
        }[step]()
        if (refToFocus) {
          refToFocus.focus()
          setTimeout(refToFocus.focus, 200)
        }
      })
    },
  },
}
</script>
